import { Link } from 'react-router-dom'

import {
  ApiSwitchInInstruction,
  ApiSwitchInOperation,
  useGetByTenantAccountInprogressAndAccountIdentifierQuery
} from '@/api/rtk-api'
import { PATH, TENANT } from '@/const'
import { Currency } from '@/utilities/currency'

import classes from '../index.module.scss'
import { Loading } from '../Loading'
import { Amount, MetaInformation } from './event-information'

const AccountName = ({
  accountId,
  date,
  source
}: {
  accountId: string
  date: Date
  source: string
}) => {
  const { data, isLoading } = useGetByTenantAccountInprogressAndAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: accountId
  })

  if (isLoading) return <Loading />

  return (
    <span>
      Switch Out Trade:{' '}
      {data.status === 'PendingActivation' || data.status === 'Activating' ? (
        <strong>{data.accountName}</strong>
      ) : (
        <Link
          className={classes.tradeLink}
          to={PATH.reportsSingleTradeEventsHoldings(source, accountId, date)}
        >
          <strong>{data.accountName}</strong>
        </Link>
      )}
    </span>
  )
}

export interface SwitchInProps {
  currency: Currency
  date: Date
  operation: ApiSwitchInOperation
  source: string
}

export const SwitchIn = ({ currency, date, operation, source }: SwitchInProps) => {
  const instruction = operation.associatedInstruction as ApiSwitchInInstruction
  return (
    <MetaInformation>
      <Amount currency={currency} value={instruction.switchAmount} />
      <AccountName accountId={instruction.originatingAccountId} date={date} source={source} />
    </MetaInformation>
  )
}
